module.exports = __webpack_public_path__ + "static/media/map-spain-ar.cd7245e8.png";